import { connect } from 'react-redux';
import type { Dispatch } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { AppThunkDispatch } from 'src/redux/store';
import type { SortOptionValue } from 'src/types';
import {
  updateFilters,
  UpdateFiltersActionType,
} from '../../../../redux/products/thunks/updateFilters';
import { SortBy } from '../components/SortBy';
import {
  selectSelectedSortingOptionInSentenceCase,
  selectSortingOptionsInSentenceCase,
} from '../modules/selectors';
import { actions as filterMenuActions } from '../modules/slice';

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSelectSortOption: (value: SortOptionValue) => {
    dispatch(filterMenuActions.selectSortOption(value));
    (dispatch as AppThunkDispatch)(updateFilters(UpdateFiltersActionType.SORT));
  },
});

export const mapStateToProps = (state: ReduxApplicationState) => ({
  isLoading: state.products.isLoading,
  sortingOptions: selectSortingOptionsInSentenceCase(state),
  selectedSortOption: selectSelectedSortingOptionInSentenceCase(state),
});

export const SortByContainer = connect(mapStateToProps, mapDispatchToProps)(SortBy);
